import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ORIENTATION_RIGHT_TO_LEFT } from '@Components/D3Tree/constants';
import RsTree from '@Components/D3Tree/Tree/RsTree';
import { renderCustomNodeElement } from '@Pages/RetroSynthesis/RouteTree/components/RouteThumbnailsTreeUtils';

const NODE_WIDTH = 10;
const NODE_HEIGHT = 10;
const PADDING = 14;

function RouteThumbnailsFullTree({ tree, onTreeNodeClick }) {
  const treeContainerRef = useRef();
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [treeSize, setTreeSize] = useState();

  const onResizeLayout = ({ treeBoundaries }) => {
    const treeWidth = Math.max(treeBoundaries.xMax - treeBoundaries.xMin + 2 * NODE_WIDTH + PADDING, 2 * PADDING + NODE_WIDTH);
    const treeHeight = Math.max(treeBoundaries.yMax - treeBoundaries.yMin + NODE_HEIGHT + PADDING, 2 * PADDING + NODE_HEIGHT);
    const offsetX = Math.abs(treeBoundaries.xMin) + NODE_WIDTH / 2 + PADDING / 2;
    const offsetY = Math.abs(treeBoundaries.yMin) + NODE_HEIGHT / 2 + PADDING / 2;
    setTranslate({ x: offsetX, y: offsetY });
    setTreeSize({ width: treeWidth, height: treeHeight });
  };

  return (
    <RsTree
      className="route-thumbnail-tree--container"
      style={treeSize}
      ref={treeContainerRef}
      onNodeClick={(id, event, data) => onTreeNodeClick(event.target, data)}
      nodeSize={{ x: NODE_WIDTH, y: NODE_HEIGHT }}
      data={tree}
      separation={{
        siblings: 2,
        nonSiblings: 2,
      }}
      zoom={1}
      pathClassFunc={() => 'tree-wire'}
      zoomable={false}
      translate={translate}
      depthFactor={20}
      orientation={ORIENTATION_RIGHT_TO_LEFT}
      rootNodeClassName="node__root"
      branchNodeClassName="node__branch"
      leafNodeClassName="node__leaf"
      enableLegacyTransitions={false}
      collapsible={false}
      renderCustomNodeElement={renderCustomNodeElement}
      onResizeLayout={onResizeLayout}
    />
  );
}

RouteThumbnailsFullTree.defaultProps = {
  onTreeNodeClick: () => null,
};

RouteThumbnailsFullTree.propTypes = {
  tree: PropTypes.any,
  onTreeNodeClick: PropTypes.func,
};

export default RouteThumbnailsFullTree;
